/* Shared types for search result and category landing listings */

export const ConfigName = 'config';

export interface IArticleListItem {
    id: number,
    url: string,   
    hitId: string,    
    language: Array<string>,
    mediaType: string,
    title: string,
    isFtp: boolean,
    category?: string,
    subCategory1?:string,
    subCategory2?:string,
    subCategory3?: string,
    subCategory1Theme?: string,
    subCategory2Theme?: string,
    subCategory3Theme?: string,
    categoryTheme?: string,
    thumbnail?: string,
    teaser?: string,
    bodyParts: Array<number>,
    topics: Array<number>,
    ages: Array<number>
}

export interface IFilter {
    text: string,
    name?: string,
    value: any
}

export interface IFilterGroup {
    header: string,
    filters?: Array<IFilter>
}

export interface IDictionary<TValue> {
    [key: string]: TValue
}

/* Client-side filtering types - NOT IN USE */
export interface IArticleFilter {
    key: string,
    filter: (article: IArticleListItem) => boolean
}

export class ArticleFilterSet {

    private filters: { [key: string]: IArticleFilter };

    constructor() {
        this.filters = {};
    }

    public add(filter: IArticleFilter): void {
        if (!this.has(filter)) {
            this.filters[filter.key] = filter;
        }
    }

    public clear(): void {
        this.filters = {};
    }

    public delete(filter: IArticleFilter): void {
        if (this.has(filter)) {
            delete this.filters[filter.key];
        }
    }

    public has(filter: IArticleFilter): boolean {
        return !!this.filters[filter.key];
    }

    public get size(): number {
        return Object.keys(this.filters).length;
    }
}




// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/shared-types.ts